import React from 'react';
import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';

const DeleteMediaConfirmModal = ({ onCancel, onDelete, deleteLoader }) => {

  const { t } = useTranslation('media_gallery');
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl p-6 w-full max-w-sm shadow-lg animate-in fade-in zoom-in duration-300">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">{t("delete_media")}</h2>
        <p className="text-gray-600 text-sm mb-6">
          {t("delete_media_description")}
        </p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 text-sm font-medium"
          >
            {t("cancel")}
          </button>
          <button
            onClick={onDelete}
            className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 text-sm font-medium"
          >
            {deleteLoader ? <Loader2 className="w-4 h-4 animate-spin" /> : t('delete')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteMediaConfirmModal;
